module.exports = __webpack_public_path__ + "static/media/send-icon.9b948cf8.svg";